const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const extractData = (payload) => (payload && payload.data ? payload.data : payload);

export const initiatePosBridgePayment = async (payload, token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${process.env.REACT_APP_BASEURL}api/pos-payments/initiate`, {
    method: "POST",
    withCredentials: true,
    headers,
    body: JSON.stringify(payload),
  });

  const responsePayload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(
      (responsePayload && (responsePayload.message || responsePayload.error)) ||
        "POS bridge initiate request failed"
    );
  }

  const data = extractData(responsePayload);
  if (!(data && data.requestId)) {
    throw new Error("POS bridge initiate response is missing requestId.");
  }

  return data.requestId;
};

export const getPosBridgePaymentStatus = async (requestId, token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(
    `${process.env.REACT_APP_BASEURL}api/pos-payments/status/${requestId}`,
    {
      method: "GET",
      withCredentials: true,
      headers,
    }
  );

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(
      (payload && (payload.message || payload.error)) ||
        `Failed to fetch POS bridge payment status: ${response.statusText}`
    );
  }

  return extractData(payload);
};

export const pollPosBridgePaymentStatus = async (requestId, token, options = {}) => {
  const maxAttempts = options.maxAttempts || 360;
  const pollIntervalMs = options.pollIntervalMs || 1000;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const statusResponse = await getPosBridgePaymentStatus(requestId, token);
    const status = String((statusResponse && statusResponse.status) || "").toLowerCase();

    if (status === "completed") {
      return { status: "completed", response: statusResponse };
    }

    if (status === "cancelled" || status === "canceled") {
      return { status: "cancelled", response: statusResponse };
    }

    if (status === "failed") {
      throw new Error(
        (statusResponse && statusResponse.errorMessage) || "POS bridge payment failed."
      );
    }

    await sleep(pollIntervalMs);
  }

  throw new Error(
    "POS bridge payment is still processing. Please wait for the terminal result or check payment status again."
  );
};



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/counter/services/PosBridgePaymentService.js